<template>
  <div>
    <TopoComponent></TopoComponent>
    <div class="container vertical-align login escolha mt-4 text-center">
      <h2>Qual é a sua data de nascimento?</h2>
      <h5>
        Digite sua data de nascimento.
      </h5>
      <div class="row">
        <form @submit.prevent="validateCode()" class="form-signin">
          <div class="row">
            <input
              type="text"
              required="true"
              v-model="dataDeNascimento"
              v-mask="'##/##/####'"
              class="codigoConfirmacao form-control"
              id="dataDeNascimento"
            />
          </div>
          <div class="row">
            <div class="col">
              <button
                class="btn btn-lg btn-primary btn-block button success mt-4"
                type="submit"
              >
                Confirmar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import TopoComponent from "@/components/TopoComponent";

export default {
  name: "ValidarDataDeNascimento",
  components: { TopoComponent },
  data: () => ({
    dataDeNascimento: "",
    flagPermiteEmail: null,
    flagPermiteSms: null,
  }),
  mounted() {
    this.flagPermiteEmail = JSON.parse(sessionStorage.getItem("flagPermiteEmail"));
    this.flagPermiteSms = JSON.parse(sessionStorage.getItem("flagPermiteSms"));
  },
  methods: {
    validateCode() {
      if (moment(this.dataDeNascimento, "DD/MM/YYYY", true).isValid()) {
        const token = sessionStorage.getItem("token");
        this.$conexaApi
          .post(
            `/integration/ativacao/paciente/${token}/validar-data-nascimento`,
            {
              dataNascimento: this.dataDeNascimento,
            }
          )
          .then(() => {
            this.$router.push(`/verificar-dados/titular`)
          })
          .catch((error) => {
            this.$notify({
              group: "mensagens",
              text:
                (error.response &&
                  error.response.data &&
                  error.response.data.msg) ||
                `Ocorreu um erro ao validar a data`,
              type: "error",
            });
          })
          .finally(() => {
            NProgress.done();
          });
      } else {
        this.$notify({
          group: "mensagens",
          text: `Data inválida`,
          type: "error",
        });
        return;
      }
    },
  },
};
</script>

<style scoped>
form,
button {
  margin: auto;
}
.codigoConfirmacao {
  border: 1px solid #4eb4e7;
  font: 3ch consolas, monospace;
  letter-spacing: 0.5ch;
  text-align: center;
  color: #4eb4e7;
}
.button {
  cursor: pointer;
}
</style>
